
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import { createArticuloPrecio } from '../../../Services/articuloPrecioService';


function getMensajeErrorArticuloPrecio(error) {
  const mensaje = error?.response?.data?.message || '';
  if (mensaje.includes('Duplicate entry')) {
    return 'Ya existe un precio para este artículo en la lista seleccionada.';
  }
  if (mensaje.includes('no existe')) {
    return 'El artículo ingresado no existe.';
  }
  return mensaje || 'No se pudo guardar el precio de artículo.';
}


const useCreateArticuloPrecio = (history, listaPrecioId) => {
  const initialValues = {
    codigoArticulo: '',
    precio: '',
  }

  const validationSchema = Yup.object({
    codigoArticulo: Yup.string()
      .required('El código de artículo es obligatorio'),
    precio: Yup.number()
      .typeError('Debe ingresar un número')
      .required('El precio es obligatorio')
      .min(0.01, 'El precio debe ser mayor a 0'),
  })

  const onSubmit = (values, { setSubmitting }) => {
    const articuloPrecio = {
      codigoArticulo: values.codigoArticulo,
      precio: values.precio,
      listaPrecioId: listaPrecioId,
    }

    createArticuloPrecio(articuloPrecio)
      .then((res) => {
        Swal.fire({
          title: 'El precio se guardó correctamente.',
          type: 'success',
          showConfirmButton: false,
          timer: 2000,
        })
        history.goBack()
      })
      .catch((error) => {

        Swal.fire({
          title: 'Error al guardar el precio del artículo',
          text: getMensajeErrorArticuloPrecio(error),
          type: 'error',
          showConfirmButton: true,
        })
      })
      .finally(() => setSubmitting(false))
  }

  return { initialValues, validationSchema, onSubmit, }
}

export default useCreateArticuloPrecio